export const COMPANY_TYPES = [
    { value: "CORPORATION",                    label: "Anonim Şirket" },
    { value: "SOLE_PROPRIETORSHIP",            label: "Şahıs İşletmesi" },
    { value: "ORDINARY_PARTNERSHIP",           label: "Adi Ortaklık" },
    { value: "COLLECTIVE_COMPANY",             label: "Kollektif Şirket" },
    { value: "COMMANDITE_COMPANY",             label: "Adi Komandit Şirket" },
    { value: "JOINT_STOCK_COMMANDITE_COMPANY", label: "Eshamlı Komandit Şirket" },
    { value: "LIMITED_COMPANY",                label: "Limited Şirket" },
    { value: "COOPERATIVE",                    label: "Kooperatif" },
    { value: "FOREIGN_PERSON",                 label: "Yabancı Kişi" },
    { value: "APARTMENT_MANAGEMENT",           label: "Apartman Yönetimi" },
    { value: "LAW_FIRM_PARTNERSHIP",           label: "Avukatlık Ortaklığı" },
    { value: "PRESS_ORGANIZATION",             label: "Basın" },
    { value: "UNION_OR_ASSOCIATION",           label: "Birlik ve Üst Birlik" },
    { value: "ASSOCIATION",                    label: "Dernek" },
    { value: "JOINT_VENTURE",                  label: "İş Ortaklığı" },
    { value: "TRADE_UNION",                    label: "Sendika" },
    { value: "SITE_MANAGEMENT",                label: "Site Yönetimi" },
    { value: "POLITICAL_PARTY",                label: "Siyasi Parti" },
    { value: "SPORTS_CLUB",                    label: "Spor Kulübü" },
    { value: "FOUNDATION",                     label: "Vakıf" },
    { value: "STATE_ECONOMIC_ENTERPRISE",      label: "Kamu İktisadi Teşebbüsü" },
    { value: "MUNICIPAL_ENTERPRISE",           label: "Belediye İktisadi Teşebbüsü" },
];

export const COMPANY_TYPE_LABEL_MAP = COMPANY_TYPES.reduce((acc, cur) => {
    acc[cur.value] = cur.label;
    return acc;
}, {});

export const COMPANY_TYPE_BADGE_COLORS = {
    CORPORATION: "#71C29B",
    SOLE_PROPRIETORSHIP: "#7AA7F5",
    ORDINARY_PARTNERSHIP: "#9C88FF",
    COLLECTIVE_COMPANY: "#20C997",
    COMMANDITE_COMPANY: "#17A2B8",
    JOINT_STOCK_COMMANDITE_COMPANY: "#6F42C1",
    LIMITED_COMPANY: "#00B894",
    COOPERATIVE: "#E17055",
    FOREIGN_PERSON: "#636E72",
    APARTMENT_MANAGEMENT: "#55EFC4",
    LAW_FIRM_PARTNERSHIP: "#FAB1A0",
    PRESS_ORGANIZATION: "#E84393",
    UNION_OR_ASSOCIATION: "#00CEC9",
    ASSOCIATION: "#81ECEC",
    JOINT_VENTURE: "#A29BFE",
    TRADE_UNION: "#FF7675",
    SITE_MANAGEMENT: "#74B9FF",
    POLITICAL_PARTY: "#D63031",
    SPORTS_CLUB: "#FDCB6E",
    FOUNDATION: "#2D3436",
    STATE_ECONOMIC_ENTERPRISE: "#6C5CE7",
    MUNICIPAL_ENTERPRISE: "#E17055",
};

export const RECEIPT_TYPE_LABEL_MAP = {
    CASH: "Nakit",
    CREDIT_CARD: "Kredi Kartı",
    BANK_TRANSFER: "Havale/EFT",
    CHECK: "Çek",
    PROMISSORY_NOTE: "Senet"
};

export const RECEIPT_TYPE_BADGE_COLORS = {
    CASH: "#198754",          // yeşil
    CREDIT_CARD: "#0d6efd",   // mavi
    BANK_TRANSFER: "#20c997", // teal
    CHECK: "#ffc107",         // sarı
    PROMISSORY_NOTE: "#6f42c1"// mor
};